'use strict';

/**
 * Listing of the recent imports
 *
 * @category   View
 * @module     settings
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ColidoCompositeView = require('base/Colido.CompositeView');
var ImportRecentListItem = require('./import-recent-list-item');

var template = require('../../templates/partials/import-recent-list.hbs');

var ImportRecentList = ColidoCompositeView.extend({
    template: template,
    childView: ImportRecentListItem,
    childViewContainer: 'tbody',
    sortDefault: 'id.desc',
});

module.exports = ImportRecentList;